import React from 'react';
import { ArrowRight } from 'lucide-react';

const getPriorityBadge = (priority, fonts) => {
    const baseStyle = {
        padding: "0.25rem 0.625rem",
        borderRadius: "0.75rem",
        fontSize: fonts.small,
        fontWeight: "600",
        display: "inline-flex",
        alignItems: "center",
        gap: "0.25rem",
    };

    const priorityConfig = {
        low: { bg: "#e0f2fe", color: "#0369a1", text: "Low" },
        medium: { bg: "#fef3c7", color: "#92400e", text: "Medium" },
        high: { bg: "#fee2e2", color: "#991b1b", text: "High" },
    };

    const config = priorityConfig[priority] || priorityConfig.medium;

    return (
        <span style={{ ...baseStyle, backgroundColor: config.bg, color: config.color }}>
            {config.text}
        </span>
    );
};

function MappingPreview({ styles, fonts, formData, getGroupById }) {
    const { escalation_type, issuerGroupId, assignedGroupId, priority } = formData;

    if (!escalation_type || !issuerGroupId || !assignedGroupId || !priority) {
        return null;
    }

    return (
        <div style={styles.previewCard}>
            <h4 style={{
                margin: "0 0 1rem 0",
                color: "#22c55e",
                fontSize: fonts.subtitle,
                fontWeight: "600"
            }}>
                Mapping Preview
            </h4>
            <div style={styles.mappingFlow}>
                <div style={styles.flowItem}>
                    <div style={{ fontSize: fonts.tiny, opacity: 0.7, marginBottom: "0.25rem" }}>
                        Type & Priority
                    </div>
                    <div style={{ fontWeight: "600", fontSize: fonts.body }}>
                        {escalation_type}
                    </div>
                    <div style={{ marginTop: "0.5rem" }}>
                        {getPriorityBadge(priority, fonts)}
                    </div>
                </div>

                <ArrowRight size={24} style={styles.flowArrow} />

                <div style={styles.flowItem}>
                    <div style={{ fontSize: fonts.tiny, opacity: 0.7, marginBottom: "0.25rem" }}>
                        From (Issuer)
                    </div>
                    <div style={{ fontWeight: "600", fontSize: fonts.body }}>
                        {getGroupById(issuerGroupId)?.groupName}
                    </div>
                    <div style={{ fontSize: fonts.tiny, opacity: 0.7, marginTop: "0.25rem" }}>
                        {getGroupById(issuerGroupId)?.creatorSr}
                    </div>
                </div>

                <ArrowRight size={24} style={styles.flowArrow} />

                <div style={styles.flowItem}>
                    <div style={{ fontSize: fonts.tiny, opacity: 0.7, marginBottom: "0.25rem" }}>
                        To (Assigned)
                    </div>
                    <div style={{ fontWeight: "600", fontSize: fonts.body }}>
                        {getGroupById(assignedGroupId)?.groupName}
                    </div>
                    <div style={{ fontSize: fonts.tiny, opacity: 0.7, marginTop: "0.25rem" }}>
                        {getGroupById(assignedGroupId)?.creatorSr}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MappingPreview;